import { Icon } from "../ui/Icon";

/** The rest of a long list folded into one row you open ("Show 4 more"); its arrow turns as it opens. */
export function Fold({ title, line, isOpen, onClick }: { title: string; line?: string; isOpen: boolean; onClick: () => void }) {
  return (
    <button type="button" className="k-fold" aria-expanded={isOpen} onClick={onClick}>
      <span className="k-fold-t">
        <b>{title}</b>
        {line ? <span>{line}</span> : null}
      </span>
      <span className="k-fold-c">
        <Icon name="down" />
      </span>
    </button>
  );
}
